import { render, staticRenderFns } from "./CustomElementList.vue?vue&type=template&id=32d150fe&scoped=true&"
import script from "./CustomElementList.vue?vue&type=script&lang=js&"
export * from "./CustomElementList.vue?vue&type=script&lang=js&"
import style0 from "./CustomElementList.vue?vue&type=style&index=0&id=32d150fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d150fe",
  null
  
)

export default component.exports